import Cookies from 'js-cookie'
import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type IOauthTokens from '@/models/Authentication/OauthTokens'

export default {
  getToken(params: object) {
    const appStore = useAppStore()
    const xsrfToken = Cookies.get('XSRF-TOKEN')

    return axios.post<object, IOauthTokens>(
      `${appStore.config.AUTH_BASE_URL}/oauth/token-with-session`,
      params,
      {
        headers: { 'X-XSRF-TOKEN': xsrfToken },
        withCredentials: true,
      },
    )
  },

  getLoggedInMyFJUser() {
    const appStore = useAppStore()

    return axios.get<App.Http.Resources.Login.UserMyFJV2Resource>(`${appStore.config.AUTH_BASE_URL}/api/myfj-v2-user`)
  },

  getLoggedInMyFJUserShadow(shadowedStudentId: number) {
    const appStore = useAppStore()

    return axios.get<App.Http.Resources.Login.UserMyFJV2Resource>(`${appStore.config.AUTH_BASE_URL}/api/myfj-v2-user-shadow`,
      { params: { shadowed_student_id: shadowedStudentId } }
    )
  },

  refreshToken(params: IOauthTokens) {
    const appStore = useAppStore()
    const xsrfToken = Cookies.get('XSRF-TOKEN')

    return axios.post<IOauthTokens, IOauthTokens>(
      `${appStore.config.AUTH_BASE_URL}/oauth/token-with-session`,
      params,
      {
        headers: { 'X-XSRF-TOKEN': xsrfToken },
        withCredentials: true,
      },
    )
  },
}
